import React from 'react';

/**
 * Mapeo de tipos de evento a etiquetas
 */
const EVENT_TYPE_LABELS = {
  // Contratación
  ingreso: 'Ingreso',
  contrato_inicial: 'Contrato Inicial',
  periodo_prueba: 'Período de Prueba',

  // Contractual
  renovacion_contrato: 'Renovación de Contrato',
  cambio_tipo_contrato: 'Cambio de Tipo de Contrato',
  adenda_contractual: 'Adenda Contractual',

  // Salarial
  aumento_salarial: 'Aumento Salarial',
  ajuste_salarial: 'Ajuste Salarial',
  cambio_forma_pago: 'Cambio de Forma de Pago',
  bonificacion: 'Bonificación',

  // Organizacional
  promocion: 'Promoción',
  cambio_departamento: 'Cambio de Departamento',
  cambio_posicion: 'Cambio de Posición',
  traslado: 'Traslado',
  cambio_jornada: 'Cambio de Jornada',
  cambio_supervisor: 'Cambio de Supervisor',

  // Disciplinario
  amonestacion_verbal: 'Amonestación Verbal',
  amonestacion_escrita: 'Amonestación Escrita',
  suspension: 'Suspensión',
  acta_administrativa: 'Acta Administrativa',

  // Reconocimiento
  felicitacion: 'Felicitación',
  reconocimiento: 'Reconocimiento',
  premio: 'Premio',
  certificacion: 'Certificación',

  // Capacitación
  capacitacion_interna: 'Capacitación Interna',
  capacitacion_externa: 'Capacitación Externa',
  certificacion_profesional: 'Certificación Profesional',

  // Ausencias
  vacaciones: 'Vacaciones',
  permiso: 'Permiso',
  licencia_medica: 'Licencia Médica',
  incapacidad: 'Incapacidad',
  ausencia_injustificada: 'Ausencia Injustificada',

  // Terminación
  renuncia: 'Renuncia',
  despido: 'Despido',
  terminacion_contrato: 'Terminación de Contrato',
  retiro: 'Retiro',

  // Documentos
  documento_subido: 'Documento Subido',
  documento_aprobado: 'Documento Aprobado',
  documento_vencido: 'Documento Vencido',

  // Otros
  cambio_datos_personales: 'Cambio de Datos Personales',
  cambio_emergencia: 'Cambio de Contacto de Emergencia',
  nota_general: 'Nota General',
  otro: 'Otro'
};

/**
 * Clases completas por categoría (strings literales para que Tailwind no las purgue)
 */
const CATEGORY_BADGE_CLASSES = {
  contratacion:  'bg-blue-100 text-blue-800',
  contractual:   'bg-blue-100 text-blue-800',
  administrativo:'bg-gray-100 text-gray-800',
  salarial:      'bg-green-100 text-green-800',
  organizacional:'bg-blue-100 text-blue-800',
  disciplinario: 'bg-red-100 text-red-800',
  reconocimiento:'bg-amber-100 text-amber-800',
  capacitacion:  'bg-green-100 text-green-800',
  ausencia:      'bg-amber-100 text-amber-800',
  terminacion:   'bg-gray-100 text-gray-800',
  documento:     'bg-gray-100 text-gray-800',
  otro:          'bg-gray-100 text-gray-800',
};

/**
 * Componente de badge para tipos de eventos
 */
export default function EventTypeBadge({ tipo_evento, categoria, className = '' }) {
  const label = EVENT_TYPE_LABELS[tipo_evento] || tipo_evento;
  const cls = CATEGORY_BADGE_CLASSES[categoria] || 'bg-gray-100 text-gray-800';

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${cls} ${className}`}>
      {label}
    </span>
  );
}

/**
 * Obtener label de tipo de evento
 */
export function getEventTypeLabel(tipo_evento) {
  return EVENT_TYPE_LABELS[tipo_evento] || tipo_evento;
}
